import { createContext } from 'react';

export const DEFAULT_LOAN_ACTION_RUN_STATE = {
  isLoading: false,
  isDataLoaded: false,
  executingActionId: null,
  disabledLoanActionsSet: new Set(),
  onLoanActionClick: () => null,
};

export const LoanActionRunnerStateContext = createContext(DEFAULT_LOAN_ACTION_RUN_STATE);
